// Read-only access to the AWS SSM tenant automation runs (provisioning, migration, password reset).
async function request(path) {
  const authToken = await localStorage.getItem("token");
  const response = await fetch(
    new Request(`${process.env.REACT_APP_API_BASE_URL}${path}`, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: authToken,
      }),
    })
  );
  const json = await response.json();
  if (!response.ok) {
    throw new Error(json?.message || json?.error || `Request failed (${response.status})`);
  }
  return json;
}

let AutomationExecution = {
  // params: { limit, next_token, action, status }
  get: async function (params = {}) {
    const clean = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
    );
    const query = Object.keys(clean).length ? `?${new URLSearchParams(clean).toString()}` : "";
    const json = await request(`/support/automation-execution${query}`);
    return { data: json.data || [], next_token: json.pagination?.next_token || null };
  },
  load: async function (execution_id) {
    const json = await request(`/support/automation-execution/${execution_id}`);
    return json.data;
  },
};

export default AutomationExecution;
